import React from 'react';
import {
  FaLinkedin, FaGithub, FaTwitter, FaEnvelope, FaMedium
} from 'react-icons/fa';
import { SiPeerlist } from 'react-icons/si';
import { AiOutlineFundProjectionScreen } from 'react-icons/ai';

const socialLinks = [
  { icon: <FaLinkedin />, label: 'LinkedIn', url: 'https://www.linkedin.com/in/navya-malhotra-b5b411232/' },
  { icon: <FaGithub />, label: 'GitHub', url: 'https://github.com/navyamalhotra78' },
  { icon: <FaTwitter />, label: 'Twitter', url: 'https://twitter.com/_NavyaMalhotra_' },
  { icon: <FaEnvelope />, label: 'Email', url: 'mailto:your-navya0807@gmail.com' },
  { icon: <SiPeerlist />, label: 'Peerlist', url: 'https://peerlist.io/navyamalhotra' },
  { icon: <AiOutlineFundProjectionScreen />, label: 'Wellfound', url: 'https://wellfound.com/u/navya-malhotra' },
  { icon: <FaMedium />, label: 'Medium', url: 'https://medium.com/@navyamalhotra' },
];

const Jupiter = () => {
  return (
    <section style={styles.section}>
      <div style={styles.container}>
        <h1 style={styles.heading}>✨ Let's Connect</h1>
        <p style={styles.description}>
          Have an idea, a project, or just want to say hi? I’m always open to creative 
          collaborations, new opportunities, or simply connecting. I’d love to hear from you!
        </p>

        <div style={styles.iconGrid}>
          {socialLinks.map((link, index) => (
            <a
              key={index}
              href={link.url}
              target="_blank"
              rel="noopener noreferrer"
              style={styles.iconButton}
              onMouseEnter={(e) => e.currentTarget.style.boxShadow = '0 0 12px #ffb86b'}
              onMouseLeave={(e) => e.currentTarget.style.boxShadow = 'none'}
              aria-label={link.label}
              title={link.label}
            >
              {link.icon}
            </a>
          ))}
        </div>

        <div style={styles.resumeBox}>
          <a
            href="https://drive.google.com/file/d/1hq5Mm-siXP5f__Gi7zR48JKr4KKVGDnR/view"
            target="_blank"
            rel="noopener noreferrer"
            style={styles.resumeLink}
          >
            📄 View My Resume
          </a>
        </div>
      </div>
    </section>
  );
};

const styles = {
  section: {
    background: 'radial-gradient(circle at top, #1c0f10, #000)',
    backgroundImage: 'url("/stars.svg")',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    minHeight: '100vh',
    padding: '30px 20px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    marginTop:'-60px'
  },
  container: {
    maxWidth: '700px',
    width: '100%',
    padding: '40px 30px',
    borderRadius: '20px',
    backdropFilter: 'blur(12px)',
    border: '1px solid #cc8844aa',
    boxShadow: '0 0 20px rgba(204, 136, 68, 0.35)',
    borderLeft: '6px solid #cc8844',
    color: '#ffcc99',
  },
  heading: {
    fontSize: '2.6rem',
    marginBottom: '12px',
    background: 'linear-gradient(90deg, #ffb86b, #ffcc99, #ffb86b)',
    backgroundClip: 'text',
    WebkitBackgroundClip: 'text',
    color: 'transparent',
    WebkitTextFillColor: 'transparent',
    animation: 'shimmer 3s linear infinite',
  },
  description: {
    color: '#eee',
    fontSize: '1.2rem',
    marginBottom: '30px',
  },
  iconGrid: {
    display: 'flex',
    justifyContent: 'center',
    gap: '25px',
    flexWrap: 'wrap',
    marginBottom: '40px',
  },
  iconButton: {
    backgroundColor: 'rgba(255, 184, 107, 0.15)',
    borderRadius: '50%',
    width: '54px',
    height: '54px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#ffb86b',
    fontSize: '1.7rem',
    textDecoration: 'none',
    transition: 'box-shadow 0.3s ease',
    cursor: 'pointer',
  },
  resumeBox: {
    padding: '15px 25px',
    border: '1px dashed #ffb86b',
    borderRadius: '12px',
    backgroundColor: 'rgba(255, 184, 107, 0.05)',
    display: 'inline-block',
  },
  resumeLink: {
    color: '#ffb86b',
    fontSize: '1.1rem',
    fontWeight: 'bold',
    textDecoration: 'none',
  },
};

export default Jupiter;
